import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable, Subscriber, finalize } from 'rxjs';

import { CountryChangeStatusEnum } from '../models/status';
import { CountryChangerService } from './country-changer.service';

@Injectable()
export class CountryChangeGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _countryChangerService: CountryChangerService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      this._countryChangerService
        .getStatus()
        .pipe(finalize(() => observer.complete()))
        .subscribe(
          (status) =>
            status.status === CountryChangeStatusEnum.new
              ? this.checkFailed(observer)
              : this.checkPassed(observer),
          () => this.checkFailed(observer),
        );
    });
  }

  checkPassed(observer: Subscriber<boolean>) {
    observer.next(true);
  }

  checkFailed(observer: Subscriber<boolean>) {
    this._router.navigate(['profile']);

    observer.next(false);
  }
}
